import { PickupOrder } from '@/api/pickup-orders/types/PickupOrder'
import { PkgWarehouse } from '@/api/user-package/types/UserPkg'
import { BrandPreview } from '@/components/BrandPreview'
import { getPickupOrderStatus } from '@/helpers/pkgUtils'

interface Props {
  order: PickupOrder
}

const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}.${month}.${year}`
}

export const PickupOrderPreview = ({ order }: Props) => {
  const status = getPickupOrderStatus(order)
  const warehouse = order.warehouse as PkgWarehouse

  return (
    <div className='border-border-default flex flex-col gap-4 overflow-hidden rounded-2xl border bg-white p-4 shadow-sm'>
      {/* Header Section */}
      <div className='flex items-start justify-between'>
        {/* Brand and Warehouse */}
        <BrandPreview brand={'Primark'} warehouse={warehouse} />

        {/* Status Badge */}
        {status && (
          <div className='text-text-secondary bg-button-primary-selected-segment rounded-full px-3 py-1 text-center text-xs'>{status}</div>
        )}
      </div>

      {/* Order Details */}
      <div className='flex flex-wrap items-center gap-8 text-sm'>
        {/* Creation Date */}
        <div>
          <p className='text-text-secondary mb-1 text-xs'>תאריך הזמנה</p>
          <p className='font-medium'>{formatDate(order.createdAt)}</p>
        </div>

        {/* Order Number */}
        <div>
          <p className='text-text-secondary mb-1 text-xs'>מספר הזמנה</p>
          <p className='font-medium'>{order.orderNumber}</p>
        </div>

        {/* Pickup Date */}
        <div>
          <p className='text-text-secondary mb-1 text-xs'>תאריך איסוף</p>
          <p className='font-medium'>{formatDate(order.pickupDate)}</p>
        </div>
      </div>
    </div>
  )
}
